export function removeEmptyProperties<T extends Record<string, any>>(obj: T): T {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== null && v !== undefined && v !== '')) as T;
}

export function isObject(obj: unknown): boolean {
  return typeof obj === 'object' && obj !== null;
}

export function countActiveFilters(
  filters: object,
  options: { defaults?: Record<string, unknown>; ignore?: string[] } = {}
): number {
  const { defaults = {}, ignore = [] } = options;
  const entries = filters as Record<string, unknown>;

  return Object.keys(entries).filter(key => {
    if (ignore.includes(key)) {
      return false;
    }

    const value = entries[key];
    const defaultValue = key in defaults ? defaults[key] : '';

    if (Array.isArray(value)) {
      return value.length > 0;
    }

    if (typeof value === 'string') {
      return value.trim() !== '' && value !== defaultValue;
    }

    return value != null && value !== defaultValue;
  }).length;
}

export function isEmpty(value) {
  if (value == null) {
    return true;
  }

  if (Array.isArray(value) || typeof value === 'string') {
    return value.length === 0;
  }

  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }

  return false;
}
